import RegisterMasterClaimForm from 'components/features/register-master-claim-form';
import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';
import { EDashboardTab } from 'components/features/dashboard-tabs/types';
import { ENavigationPath } from 'constants/path';

function RegisterNewMasterClaim() {
  const { t } = useTranslation();
  return (
    <HomeLayout
      title={t('claim.claim')}
      backNavigationState={{ activeTab: EDashboardTab.CLAIM }}
      backDestinationPath={ENavigationPath.DASHBOARD}
    >
      <RegisterMasterClaimForm />
    </HomeLayout>
  );
}

export default RegisterNewMasterClaim;
